<template>
  <div>
    <div class="d-flex">
      <img :src="data.customerPicture" class="picture-icon" />
      <div class="pl-5 pr-5">
        <span>{{ data.customerName }}</span>
        <div class="d-flex align-items-center">
          <div>
            <base-icon-site :data-type="data.typeName" font-size="25" icon-size="40" />
          </div>
          <div class="pl-4 pr-4">
            <base-icon-pin :data-distance="data.distance" font-size="25" icon-size="40" />
          </div>
          <btn-visit-status
            :message="data.statusName"
            :backgroundColor="data.backgroundColor"
            :textColor="data.textColor"
            style="width: auto;padding: 5px 25px;"
          >
          </btn-visit-status>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data']
}
</script>
